export type LogicalConnector = "AND" | "OR";
export type LogicalOperator = "NOT";

export type UnderstandingRepresentation = {
  name: string;
  question: string;
  line?: string;
  logicalConnective?: LogicalConnector;
  logicalOperator?: LogicalOperator;
  subConditions?: UnderstandingRepresentation[];
};

export enum UpdateType {
  PRE_EVALUATED = "PRE_EVALUATED",
  REPHRASING = "REPHRASING",
  SPLIT_OUT = "SPLIT_OUT",
  MERGE = "MERGE",
  MANUAL_EDIT = "MANUAL_EDIT",
  AUTOMATIC_INSERTION = "AUTOMATIC_INSERTION",
  HIL_CONTEXT = "HIL_CONTEXT",
  INLINED = "INLINED",
  LOGICALLY_ELIMINATED = "LOGICALLY_ELIMINATED",
}

export interface UpdatedNodeInfo {
  nodeName: string;
  updateType: UpdateType;
  explanation: string;
  note?: string;
  original?: string;
  rephrased?: string;
  sourceNode?: string;
  mergedWith?: string[];
  splitText?: string[];
}
